<template>
  <div class="modal__cover" @click.self="onClickModalCover">
    <div class="modal__content">
      <div class="modal__descriptions">
        <div class="modal__text">
          <div class="modal__text__title">
            <span>{{ titleText }}</span>
          </div>
          <div class="modal__text__caption">
            <span>{{ captionText }}</span>
          </div>
        </div>
        <div class="modal__btn">
          <div class="modal__btn--primary">
            <button
              type="button"
              class="btn btn--primary"
              style="margin: 0;"
              @click="onClickPrimaryButton"
            >
              {{ primaryButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      required: true
    },
    captionText: {
      type: String,
      required: true
    },
    primaryButtonText: {
      type: String,
      required: true
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickPrimaryButton() {
      this.$emit('clicked-primary')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal {
  &__descriptions {
    padding: 32px 24px;
  }
  &__text {
    &__title {
      white-space: pre-wrap;
    }
  }
}
</style>
